import styleGuide from './style-guide'
export default styleGuide
